import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription, of } from "rxjs";
import { catchError, tap } from 'rxjs/operators';
import { GenMSRPPrice } from 'src/app/generac/models/product.model';
import { GenProductService } from 'src/app/generac/services/product.service';

@Component({
  selector: 'gen-availability-date',
  templateUrl: './availability-date.component.html',
  imports: [CommonModule]
})
export class GenAvailabilityDateComponent implements OnInit, OnDestroy {

  subscription = new Subscription();
  price: GenMSRPPrice;
  showLeadTime: boolean = false;

  constructor(
    protected productService: GenProductService,
  ) { }

  ngOnInit(): void {
    this.subscription.add(
      this.productService
        .cpiPriceRes$$
        .pipe(
          tap(res => this.showLeadTime = res?.showLeadTime),
          tap(price => this.price = price),
          catchError(() => {
            return of(null);
          })).subscribe()
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
